import { useState } from 'react';

import { usePaymentInputs } from 'react-payment-inputs';

import { CardIcon } from '@/shared/assets';
import { CARD_NUMBER_PLACEHOLDER, COLORS, cn } from '@/shared/lib';
import { Typography } from '@/shared/ui';

interface CardDetailsItemProps {
  value: string;
  label: string;
  autoFocus?: boolean;
  placeholder?: string;
  showCardIcon?: boolean;
  inputProps:
    | Partial<ReturnType<typeof usePaymentInputs>['getCardNumberProps']>
    | Partial<ReturnType<typeof usePaymentInputs>['getExpiryDateProps']>
    | Partial<ReturnType<typeof usePaymentInputs>['getCVCProps']>;
  svgProps?: Partial<ReturnType<typeof usePaymentInputs>['getCardImageProps']>;
  foundName?: string;
  className?: string;
  maxLength?: number;
}
export const CardDetailsItem = ({
  value,
  inputProps,
  className,
  foundName,
  showCardIcon,
  label,
  autoFocus,
  svgProps,
  placeholder = CARD_NUMBER_PLACEHOLDER,
  maxLength,
}: CardDetailsItemProps) => {
  const [isFocused, setIsFocused] = useState(false);
  return (
    <div
      className={cn(
        'rounded-2xl bg-base-300 px-4 py-2.5',
        { 'bg-surface-03': isFocused },
        className,
      )}
    >
      <Typography
        className={cn('text-base-300', { 'text-light-gray': isFocused })}
        variant="12-r"
      >
        {label}
      </Typography>
      <div className="flex items-center gap-1">
        {showCardIcon &&
          (!foundName ? (
            <CardIcon color={COLORS['icon-base-500']} />
          ) : (
            <svg {...svgProps} className="h-[15px] w-[21px]" />
          ))}
        <input
          {...inputProps}
          value={value}
          autoFocus={autoFocus}
          maxLength={maxLength}
          onFocus={() => {
            setIsFocused(true);
          }}
          onBlur={() => {
            setIsFocused(false);
          }}
          className={cn(
            'w-full bg-surface-00-transparent text-base font-normal leading-5 outline-none placeholder:text-base-300',
            { 'text-base-300': !isFocused },
          )}
          placeholder={placeholder}
        />
      </div>
    </div>
  );
};
